import {useExecutionQuery} from './useExecutionsQuery';

export const useExecution = (executionId?: string) => {
    const {
        data: record,
        isLoading: loading,
        refetch: fetchRecord,
    } = useExecutionQuery(executionId || '');

    return {
        record,
        loading,
        fetchRecord,
    };
};
